/**
 * The editor's preview iframe is created with this `name`, which the framed
 * document sees as `window.name` — synchronously, on the very first render,
 * and across every navigation within the frame. That lets a page know it
 * is the editor's preview even when the author navigated it to a live page
 * route (where `isDraftPreview` is not served), so it keeps its own scroll
 * viewport and stays out of the public embed's height-reporting protocol.
 */
export const EDITOR_PREVIEW_FRAME_NAME = 'diagonal-page-editor-preview';

export function isInsideEditorPreviewFrame(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.self !== window.top &&
    window.name === EDITOR_PREVIEW_FRAME_NAME
  );
}
